<template>
    <div>
        <!-- Stores Section -->
        <div class="mt-4">
            <div @click="toggleStoresState" class=" cursor-pointer flex items-center justify-between transition-height-transform  duration-200 delay-300 ">
                <div class="flex flex-col gap-2 flex-1">
                    <span class=" font-semibold">{{ $t('search.stores') }}</span>
                    <!-- Display selected stores -->
                    <div v-if="selectedStoreBadges.length > 0" class="flex flex-wrap gap-2 mt-2">
                        <div 
                            v-for="selectedStore in selectedStoreBadges" 
                            :key="selectedStore.id"
                            class="flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-lg px-3 py-1.5 text-sm hover:bg-primary/15 transition-colors duration-200 group"
                        >
                            <!-- Store name -->
                            <span class="text-primary font-medium text-xs">
                                {{ selectedStore.name }}
                            </span>
                            
                            <!-- Remove button -->
                            <button 
                                @click.stop="removeStore"
                                class="ml-1 text-gray-400 hover:text-red-500 transition-colors duration-200 p-0.5 rounded-full hover:bg-red-50 group-hover:bg-red-50"
                                :title="$t('general.remove')"
                            >
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <span 
                    class="w-8 h-8 flex items-center justify-center cursor-pointer">
                    <img :class="` ${!storesState ? ' rotate-90 ' : ' rotate-0 '} transition-height-transform  cursor-pointer`"
                        src="../../assets/icons/down.svg" alt="">
                </span>
            </div>
            <div
                :class="`${!storesState ? 'min-h-[0px]' : 'min-h-[20px]'} transition-height-transform  text-[14px] text-[#484848BD]`">
                <div :class="`  ${storesState ? 'flex' : 'hidden'}  flex flex-col gap-1 text-[14px] mt-3`">

                    <form @submit.prevent="searchStores" class=" flex">
                        <input v-model="storesSearchInput"
                            class=" border border-[#C6C6C6] rounded-tr-md rounded-br-md " type="text" name=""
                            id="" :placeholder="$t('search.search_for_store')">
                        <button :disabled="isStoreLoading"
                            class=" w-[50px] rounded-tl-md rounded-bl-md  flex items-center justify-center bg-primary disabled:opacity-60">
                            <img src="../../assets/icons/search.svg" alt="">
                        </button>
                    </form>

                    <div>
                        <div v-if="stores.length">
                            <div v-for="(item, idx) in stores " :key="idx" class="mt-1  ">
                                <div @click="selectStore(item.id)" class="flex gap-2 cursor-pointer ">
                                    <span :class="`flex items-center justify-center rounded-full border-[1.5px] w-[25px] h-[25px]  ${item.isSelected ? 'border-primary' : 'border-[#E5E5E5]'
                                        } `">
                                        <span v-if="item.isSelected"
                                            :class="`block rounded-full  bg-primary w-[11px] h-[11px] `"></span>
                                    </span>
                                    <div class="flex items-center gap-1">
                                        <img v-if="!item.noImg" class=" h-[30px] w-[30px] rounded-full"
                                            :src="item?.logo" alt="">
                                        <span>
                                            {{ item.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="h-[100px] w-full flex items-center justify-center text-gray-600 ">
                            {{ $t('search.no_results') }}
                        </div>

                        <div v-if="stores.length && allowTogetStores && !isStoreLoading" class="mt-3">
                            <span @click="loadMoreStores"
                                class="text-primary cursor-pointer">{{
                                    $t('search.more_stores')
                                }}</span>
                        </div>

                        <div v-else-if="!allowTogetStores && stores.length && !isStoreLoading > 6"
                            class="mt-3">
                            <span @click="resetStores"
                                class="text-primary cursor-pointer">{{
                                    $t('search.show_less')
                                }}</span>
                        </div>

                        <div v-else-if="isStoreLoading" class="mt-3">
                            <span class="text-primary cursor-pointer">{{
                                $t('search.loading')
                            }}</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Governorates Section -->
        <div class="mt-4">
            <div @click="toggleGovernoratesState" class=" cursor-pointer flex items-center justify-between transition-height-transform  duration-200 delay-300 ">
                <div class="flex flex-col gap-2 flex-1">
                    <span class=" font-semibold">{{ $t('search.governorates') }}</span>
                    <!-- Display selected governorates -->
                    <div v-if="selectedGovernmentBadges.length > 0" class="flex flex-wrap gap-2 mt-2">
                        <div 
                            v-for="selectedGovernorate in selectedGovernmentBadges" 
                            :key="selectedGovernorate.id"
                            class="flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-lg px-3 py-1.5 text-sm hover:bg-primary/15 transition-colors duration-200 group"
                        >
                            <!-- Governorate name -->
                            <span class="text-primary font-medium text-xs">
                                {{ selectedGovernorate.name }}
                            </span>
                            
                            <!-- Remove button -->
                            <button 
                                @click.stop="removeGovernorate"
                                class="ml-1 text-gray-400 hover:text-red-500 transition-colors duration-200 p-0.5 rounded-full hover:bg-red-50 group-hover:bg-red-50"
                                :title="$t('general.remove')"
                            >
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <span 
                    class="w-8 h-8 flex items-center justify-center cursor-pointer">
                    <img :class="` ${!governoratesState ? ' rotate-90 ' : ' rotate-0 '} transition-height-transform  cursor-pointer`"
                        src="../../assets/icons/down.svg" alt="">
                </span>
            </div>
            <div
                :class="`${!governoratesState ? 'min-h-[0px]' : 'min-h-[20px]'} transition-height-transform  text-[14px] text-[#484848BD]`">
                <div
                    :class="`  ${governoratesState ? 'flex' : 'hidden'}  flex flex-col gap-1 text-[14px] mt-3`">
                    <form class=" flex">
                        <input class=" border border-[#C6C6C6] rounded-md  " type="text" name="" id=""
                            :placeholder="$t('search.search_gov')" v-model="govSearchInput" @input="searchGovernorate">
                    </form>

                    <div>
                        <div v-if="filteredGovernorates?.length">
                            <div v-for="(item, idx) in filteredGovernorates " :key="idx" class="mt-1  ">
                                <div class="mt-1">
                                    <RadioBtn :title="item.name_ar" :toShow="item?.isSelected"
                                        @fun="selectGovernorate(item.id)" />
                                </div>
                            </div>
                        </div>

                        <div v-else class="h-[100px] w-full flex items-center justify-center text-gray-600 ">
                            {{ $t('search.no_results') }}
                        </div>

                        <div v-if="governorates.length != allGovernorates.length && !govSearchInput.length"
                            class="mt-3">
                            <span @click="showMoreGovernorates" class="text-primary cursor-pointer">{{
                                $t('search.more_governorates')
                            }}</span>
                        </div>

                        <div v-else-if="!govSearchInput.length" class="mt-3">
                            <span @click="showLessGovernorates" class="text-primary cursor-pointer">{{
                                $t('search.show_less')
                            }}</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        
        <!-- Areas Section -->
        <div class="mt-4">
            <div @click="toggleAreasState" class=" cursor-pointer flex items-center justify-between transition-height-transform  duration-200 delay-300 ">
                <div class="flex flex-col gap-2 flex-1">
                    <span class=" font-semibold">{{ $t('search.areas') }}</span>
                    <!-- Display selected areas -->
                    <div v-if="selectedAreaBadges.length > 0" class="flex flex-wrap gap-2 mt-2">
                        <div 
                            v-for="selectedArea in selectedAreaBadges" 
                            :key="selectedArea.id"
                            class="flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-lg px-3 py-1.5 text-sm hover:bg-primary/15 transition-colors duration-200 group"
                        >
                            <!-- Area name -->
                            <span class="text-primary font-medium text-xs">
                                {{ selectedArea.name }}
                            </span>
                            
                            <!-- Remove button -->
                            <button 
                                @click.stop="removeArea"
                                class="ml-1 text-gray-400 hover:text-red-500 transition-colors duration-200 p-0.5 rounded-full hover:bg-red-50 group-hover:bg-red-50"
                                :title="$t('general.remove')"
                            >
                                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <span 
                    class="w-8 h-8 flex items-center justify-center cursor-pointer">
                    <img :class="` ${!areasState ? ' rotate-90 ' : ' rotate-0 '} transition-height-transform  cursor-pointer`"
                        src="../../assets/icons/down.svg" alt="">
                </span>
            </div>
            <div
                :class="`${!areasState ? 'min-h-[0px]' : 'min-h-[20px]'} transition-height-transform  text-[14px] text-[#484848BD]`">
                <div :class="`  ${areasState ? 'flex' : 'hidden'}  flex flex-col gap-1 text-[14px] mt-3`">
                    <form class=" flex">
                        <input class=" border border-[#C6C6C6] rounded-md  " type="text" name=""
                            v-model="areaSearchInput" id="" :placeholder="$t('search.search_area')"
                            @input="searchArea">
                    </form>

                    <div>
                        <div v-if="filteredAreas.length">
                            <div v-for="(item, idx) in filteredAreas " :key="idx" class="mt-1  ">
                                <div class="mt-1">
                                    <RadioBtn :title="item.name_ar" :toShow="item?.isSelected"
                                        @fun="selectArea(item.id)" />
                                </div>
                            </div>
                        </div>
                        <div v-else class="h-[100px] w-full flex items-center justify-center text-gray-600 ">
                            {{ $t('search.no_results') }}
                        </div>
                        <div v-if="areas.length != allAreas.length && !areaSearchInput.length" class="mt-3">
                            <span @click="showMoreAreas" class="text-primary cursor-pointer ">{{
                                $t('search.more_areas')
                            }}</span>
                        </div>

                        <div v-else-if="!areaSearchInput.length && allAreas.length" class="mt-3">
                            <span @click="showLessAreas" class="text-primary cursor-pointer">{{
                                $t('search.show_less')
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioBtn from '~/components/generic/RadioBtn.vue'

export default {
    name: 'FilterLocation',
    components: {
        RadioBtn
    },
    props: {
        stores: {
            type: Array,
            required: true
        },
        governorates: {
            type: Array,
            required: true
        },
        allGovernorates: {
            type: Array,
            required: true
        },
        areas: {
            type: Array,
            required: true
        },
        allAreas: {
            type: Array,
            required: true
        },
        selectedStoreId: {
            type: [Number, String],
            default: null
        },
        selectedGovernorateId: {
            type: [Number, String],
            default: null
        },
        selectedAreaId: {
            type: [Number, String],
            default: null
        },
        isStoreLoading: {
            type: Boolean,
            default: false
        },
        allowTogetStores: {
            type: Boolean,
            default: true
        }
    },
    emits: ['store-selected', 'governorate-selected', 'area-selected', 'fetch-stores', 'remove-store', 'remove-governorate', 'remove-area'],
    data() {
        return {
            storesState: false,
            governoratesState: false,
            areasState: false,
            storesSearchInput: "",
            govSearchInput: "",
            areaSearchInput: "",
            filteredGovernorates: [],
            filteredAreas: []
        }
    },
    computed: {
        selectedStoreBadges() {
            if (!this.selectedStoreId) return []
            
            const selectedStore = this.stores.find(store => store.id === this.selectedStoreId)
            if (!selectedStore) return []
            
            return [{
                id: selectedStore.id,
                name: selectedStore.name,
                type: 'store'
            }]
        },
        selectedGovernmentBadges() {
            if (!this.selectedGovernorateId) return []
            
            const selectedGovernorate = this.allGovernorates.find(gov => gov.id === this.selectedGovernorateId)
            if (!selectedGovernorate) return []
            
            return [{
                id: selectedGovernorate.id,
                name: this.$i18n.locale === 'ar' ? selectedGovernorate.name_ar : selectedGovernorate.name_en,
                type: 'governorate'
            }]
        },
        selectedAreaBadges() {
            if (!this.selectedAreaId) return []
            
            const selectedArea = this.allAreas.find(area => area.id === this.selectedAreaId)
            if (!selectedArea) return []
            
            return [{
                id: selectedArea.id,
                name: this.$i18n.locale === 'ar' ? selectedArea.name_ar : selectedArea.name_en,
                type: 'area'
            }]
        }
    },
    watch: {
        governorates: {
            handler(newVal) {
                this.filteredGovernorates = newVal
            },
            immediate: true
        },
        areas: {
            handler(newVal) {
                this.filteredAreas = newVal
            },
            immediate: true
        }
    },
    methods: {
        toggleStoresState() {
            this.storesState = !this.storesState
        },
        toggleGovernoratesState() {
            this.governoratesState = !this.governoratesState
        },
        toggleAreasState() {
            this.areasState = !this.areasState
        },
        selectStore(storeId) {
            this.$emit('store-selected', storeId)
        },
        selectGovernorate(governorateId) {
            this.$emit('governorate-selected', governorateId)
        },
        selectArea(areaId) {
            this.$emit('area-selected', areaId)
        },
        searchStores() {
            this.$emit('fetch-stores', { action: 'search', search: this.storesSearchInput })
        },
        loadMoreStores() {
            this.$emit('fetch-stores', { action: 'next' })
        },
        resetStores() {
            this.$emit('fetch-stores', { action: 'reset' })
        },
        searchGovernorate() {
            if (this.govSearchInput.length) {
                this.filteredGovernorates = this.allGovernorates.filter((item) => 
                    item.name_ar.includes(this.govSearchInput) || 
                    item.name_en.toLowerCase().includes(this.govSearchInput.toLowerCase())
                )
            } else {
                this.filteredGovernorates = this.governorates
            }
        },
        showMoreGovernorates() {
            const govLength = this.governorates.length
            this.filteredGovernorates = this.allGovernorates.slice(0, (govLength + 6))
            this.$emit('governorate-selected', this.selectedGovernorateId, { expand: true })
        },
        showLessGovernorates() {
            this.filteredGovernorates = this.allGovernorates.slice(0, 6)
            this.$emit('governorate-selected', this.selectedGovernorateId, { expand: false })
        },
        searchArea() {
            if (this.areaSearchInput.length) {
                this.filteredAreas = this.allAreas.filter((item) => 
                    item.name_ar.includes(this.areaSearchInput) || 
                    item.name_en.toLowerCase().includes(this.areaSearchInput.toLowerCase())
                )
            } else {
                this.filteredAreas = this.areas
            }
        },
        showMoreAreas() {
            const areaLength = this.areas.length
            this.filteredAreas = this.allAreas.slice(0, (areaLength + 6))
            this.$emit('area-selected', this.selectedAreaId, { expand: true })
        },
        showLessAreas() {
            this.filteredAreas = this.allAreas.slice(0, 6)
            this.$emit('area-selected', this.selectedAreaId, { expand: false })
        },
        removeStore() {
            this.$emit('remove-store')
        },
        removeGovernorate() {
            this.$emit('remove-governorate')
        },
        removeArea() {
            this.$emit('remove-area')
        }
    }
}
</script>

<style scoped>
.transition-height-transform {
    transition-property: min-height, transform;
    transition-duration: 300ms;
    transition-timing-function: ease-in-out;
}
</style>

